// extracted by mini-css-extract-plugin
export default {"agendaTitle":"AgendaTitle-module__agendaTitle___3piLV"};